import { render, staticRenderFns } from "./Autonomy.vue?vue&type=template&id=0aa08d6b&"
import script from "./Autonomy.vue?vue&type=script&lang=js&"
export * from "./Autonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports